<div class="header row align-items-center">
  <div class="col">
    <h3 class="m-y-0">{{'TEXT.CUSTOMER-INFORMATION'|translate}}</h3>
  </div>
</div>

<div *ngIf="selectedCustomerType">
  <div class="box-filter position-relative z-2">
    <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

    <div class="row">
      <div class="col h-50">
        <ng-select class="custom" id="buyerName" [items]="buyerNameList"
          placeholder="{{'NORMAL.CUS-NAME'|translate}}" [(ngModel)]="searchName" [ngClass]="{'selected': searchName || searchingName}"
          (focus)="searchingName = true" (blur)="searchingName = false">
        </ng-select>
        <label class="select-label" *ngIf="searchName || searchingName"
          for="buyerName">{{'NORMAL.CUS-NAME'|translate}}</label>
      </div>

      <div class="col h-50">
        <ng-select class="custom" id="buyerTaxID" [items]="buyerTaxIDList"
          placeholder="{{'TABLE.TAX-ID'|translate}}" [(ngModel)]="searchTaxID" [ngClass]="{'selected': searchTaxID || searchingTaxID}"
          (focus)="searchingTaxID = true" (blur)="searchingTaxID = false">
        </ng-select>
        <label class="select-label" *ngIf="searchTaxID || searchingTaxID"
          for="buyerTaxID">{{'TABLE.TAX-ID'|translate}}</label>
      </div>
    </div>

    <div class="row m-t-10">
      <div class="col h-50">
        <ng-select class="custom" id="buyerBranchCode" [items]="buyerBranchCodeList"
          placeholder="{{'TABLE.BRANCH-CODE'|translate}}" [(ngModel)]="searchBranchCode"
          [ngClass]="{'selected': searchBranchCode || searchingBranchCode}" (focus)="searchingBranchCode = true"
          (blur)="searchingBranchCode = false">
        </ng-select>
        <label class="select-label" *ngIf="searchBranchCode || searchingBranchCode"
          for="buyerBranchCode">{{'TABLE.BRANCH-CODE'|translate}}</label>
      </div>

      <div class="col h-50">
        <ng-select class="custom" id="buyerBranchName" [items]="buyerBranchNameList"
          placeholder="{{'TABLE.BRANCH-NAME'|translate}}" [(ngModel)]="searchBranchName"
          [ngClass]="{'selected': searchBranchName || searchingBranchName}" (focus)="searchingBranchName = true"
          (blur)="searchingBranchName = false">
        </ng-select>
        <label class="select-label" *ngIf="searchBranchName || searchingBranchName"
          for="buyerBranchName">{{'TABLE.BRANCH-NAME'|translate}}</label>
      </div>
    </div>
  </div>


  <div class="box-parent position-relative z-1">
    <app-custom-pagination [(currentPage)]="currentPage"
        [(itemsPerPage)]="itemsPerPage"
        [totalItems]="totalItems"
        (pageChange)="pageChanged()"
        (optionChange)="optionChanged()"
        *ngIf="loading === false && totalItems !== 0">
      <button type="button" class="btn btn-dv btn-wide"
        (click)="getExportExcel()">
        {{ 'COMMON.DOWNLOAD' | translate }} Excel
      </button>
      <button type="button"
          class="btn btn-dv btn-wide"
          (click)="openModal(null, -1)">
        {{'TEXT.ADD_CUSTOMER' | translate}}
      </button>
    </app-custom-pagination>

    <div class="row m-t-20" *ngIf="list.length === 0 && loading === false">
      <div class="col-12 text-center">
        <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
      </div>
    </div>

    <div class="scrollable m-t-30">
      <table class="table text-center" *ngIf="list.length !== 0 && !loading">
        <thead>
          <tr>
            <th scope="col">{{'NORMAL.QUE'| translate}}</th>
            <th scope="col">{{'NORMAL.CUS-NAME'| translate}}</th>
            <th scope="col">{{'TABLE.BRANCH-NAME'|translate}}</th>
            <th scope="col">{{'TABLE.TAX-ID'| translate}}</th>
            <th scope="col">{{'TABLE.BRANCH-CODE'| translate}}</th>
            <th scope="col">
              <p-checkbox class="dv-checkbox" (onChange)="selectDeselectAll($event)" [ngModel]="allChecked" binary="true"> </p-checkbox>
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of list; let index = index">
            <td>{{ index + 1 + ((currentPage - 1) * itemsPerPage) }}</td>
            <td>{{ data.name }}</td>
            <td>{{ data.branch_name }}</td>
            <td>{{ data.tax_id }}</td>
            <td>{{ data.branch_code }}</td>
            <td style="text-align: center">
              <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="selectedValues[index]" (ngModelChange)="isAllSelect()"></p-checkbox>
            </td>
            <td>
              <i class="fa fa-1x fa-edit text-warning pointer m-r-5" (click)="openModal(index)"></i>
              <i class="far fa-1x fa-file text-primary pointer" (click)="issue(index)"></i>
              <i *ngIf="isAccountantAdmin"
                 class="fa fa-1x fa-trash text-danger pointer"
                 (click)="confirmDelete(index)">
              </i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row m-t-20" *ngIf="loading">
      <div class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
      </div>
    </div>
  </div>
</div>

<app-customer-detail #detailModal></app-customer-detail>

<ng-template #deleteConfirmation let-modal>
  <div class="modal-header">
    <h5>{{'COMMON.CONFIRMATION'|translate}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h6>{{'NORMAL.CUS-NAME'| translate}}: {{ modalData.name }}</h6>
        <h6>{{'COMMON.CONFIRM-DELETE-CUS'| translate}}</h6>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="col-6 text-left">
      <button type="button" class="btn btn-dv btn-danger btn-wide"
              (click)="closeModal()">{{'COMMON.CANCEL' | translate}}
      </button>
    </div>
    <div class="col-6 text-right p-0">
      <button type="button" class="btn btn-dv btn-wide" (click)="confirmedDelete(modalData.id)">
        {{'COMMON.OK' | translate}}
      </button>
    </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.html